import React from 'react';
import { Auth } from './authHook';
export const AuthContext = React.createContext<Auth>(null);
